import { queryOptions } from "@tanstack/react-query";
import type { SubscriptionResponse } from "@/app/billing/types";
import { getCoordinatorApi } from "@/lib/api";
import { billingKeys } from "./query-keys";

const fetchSubscription = async ({
  organizationId,
}: {
  organizationId: string;
}): Promise<SubscriptionResponse> => {
  const api = getCoordinatorApi({ organizationId });
  const { data } = await api.get<SubscriptionResponse>("/billing/subscription");

  return data;
};

export const subscriptionQueryOptions = ({
  organizationId,
}: {
  organizationId: string;
}) =>
  queryOptions<SubscriptionResponse>({
    queryKey: billingKeys.subscription(organizationId),
    queryFn: () => fetchSubscription({ organizationId }),
  });
